import React from 'react'

function LocationRadio({ id, icon, name, description, title, ...rest }) {
    return (
        <label htmlFor={id} className="cursor-pointer has-[:checked]:ring-primary has-[:checked]:bg-primary/5 grid grid-cols-[auto_1fr_auto] gap-3 items-center rounded-md p-4 ring-1 ring-transparent w-full">
            <input
                {...rest}
                name={name}
                id={id}
                type="radio"
                className="box-content h-2 w-2 font-serif appearance-none rounded-full border-[5px] border-white bg-white bg-clip-padding outline-none ring-1 ring-gray-950/10 checked:border-green-700 checked:ring-green-700"
            />
            <div className='font-serif'>
                <p>{title}</p>
                <small className='text-gray-500'>{description}</small>
            </div>
            {icon}
        </label>
    )
}

export default LocationRadio